export default __webpack_public_path__ + "static/media/logo_with_shadow.6f7456dd.png";